<template>
  <div class="flex flex-col text-left gap-4">
    <div
      v-for="(feature, index) in features"
      :key="index"
      class="flex flex-col"
    >
      <div class="flex flex-row items-center gap-2">
        <div class="flex flex-col">
          <div v-html="feature.icon" class="text-primary-purple w-6 h-6"></div>
        </div>
        <div
          class="text-black font-inter text-base font-semibold normal-case leading-6"
        >
          {{ feature.title }}
        </div>
      </div>
      <div class="flex flex-col">
        <a :href="meetingUrl" target="_blank" rel="noopener noreferrer">
          <img
            :src="feature.image"
            :alt="feature.title"
            class="w-full md:w-2/3 cursor-pointer"
          />
        </a>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";
import {
  DOMAIN_ICON,
  ADDITIONAL_CONDITIONS_ICON,
  SHIELD_ICON,
  WIFI_ICON,
  EXPANDED_PROFILE_ICON,
  WORKFLOWS_ICON,
  PAYOUT_SEGMENT_ICON,
  DOCUMENT_ICON,
} from "@/assets/svg/shared/svg-constants";

export default defineComponent({
  name: "ComingSoonFeatures",
  setup() {
    const meetingUrl = ref("https://meet.slashexperts.com/meet/jeff/quick");

    const features = [
      {
        title: "Domain",
        icon: DOMAIN_ICON,
        image: require("@/assets/expert-program/coming-soon-features/custom-domains.png"),
      },
      {
        title: "Additional Conditions",
        icon: ADDITIONAL_CONDITIONS_ICON,
        image: require("@/assets/expert-program/coming-soon-features/restrict-attendees.png"),
      },
      {
        title: "Security Settings",
        icon: SHIELD_ICON,
        image: require("@/assets/expert-program/coming-soon-features/security-settings.png"),
      },
      {
        title: "IP Access Control",
        icon: WIFI_ICON,
        image: require("@/assets/expert-program/coming-soon-features/ip-access-control.png"),
      },
      {
        title: "Expanded Profile",
        icon: EXPANDED_PROFILE_ICON,
        image: require("@/assets/expert-program/coming-soon-features/expanded-profile.png"),
      },
      {
        title: "After Meeting Workflows",
        icon: WORKFLOWS_ICON,
        image: require("@/assets/expert-program/coming-soon-features/workflows.png"),
      },
      {
        title: "Payout Segment",
        icon: PAYOUT_SEGMENT_ICON,
        image: require("@/assets/expert-program/coming-soon-features/payout-segments.png"),
      },
      {
        title: "Preview Page",
        icon: DOCUMENT_ICON,
        image: require("@/assets/expert-program/coming-soon-features/program-landing-page.png"),
      },
    ];

    return {
      meetingUrl,
      features,
    };
  },
});
</script>
